export default "__VITE_ASSET__D3QI2T9o__"